import React from 'react';
import { buildShopUrl, getGclid, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function DarkCta() {
  const handleClick = () => {
    trackCTAClick('Topping jetzt entdecken', 'final-cta');
  };
  const href = buildShopUrl(SHOP_URL, getGclid());
  return <div className="bg-text rounded-[16px] px-5 sm:px-[34px] py-7 sm:py-[46px] my-[3.5em] text-center" data-id="element-48">
      <p className="font-sans text-[0.68rem] font-bold tracking-[0.15em] uppercase text-amber mb-3" data-id="element-49">
        Unser Tipp für Hundeeltern
      </p>
      <h2 className="font-serif text-[1.55rem] font-bold text-white mb-[14px] leading-[1.3]" data-id="element-50">
        Juckreiz von innen angehen – mit gezielter Unterstützung der Darmflora
      </h2>
      <p className="font-sans text-[0.9rem] text-white/65 max-w-[420px] mx-auto mb-7 leading-[1.65]" data-id="element-51">
        Das Futtertopping Magen & Darm lässt sich einfach in jede
        Fütterungsroutine integrieren. 60 Tage risikofrei testen – und selbst
        sehen, ob es für deinen Hund einen Unterschied macht.
      </p>
      <a href={href} onClick={handleClick} className="inline-block bg-amber hover:bg-amber-deep text-white font-sans font-bold text-[0.92rem] no-underline rounded-full px-8 py-[14px] tracking-[0.02em] shadow-[0_4px_18px_rgba(196,124,46,0.28)] transition-all duration-200 hover:-translate-y-[2px]" rel="sponsored" target="_blank" data-id="element-52">
        Topping jetzt entdecken →
      </a>
      <p className="font-sans text-[0.73rem] text-white/40 mt-[14px]" data-id="element-53">
        Kein Abo nötig &nbsp;·&nbsp; Versand in 2–4 Werktagen &nbsp;·&nbsp; 60
        Tage Garantie
      </p>
    </div>;
}